import { IRouteConfig } from 'helpers/route-config';

import FatigueAssessments from "components/portal/fatigueAssessment/FatigueAssessments";
import FatigueAssessmentBaseForm from "components/portal/fatigueAssessment/FatigueAssessmentBaseForm";
import FatigueAssessmentOnBehalfForm from "components/portal/fatigueAssessment/FatigueAssessmentOnBehalfForm";
import FatigueAssessmentAssignForm from "components/portal/fatigueAssessment/FatigueAssessmentAssignForm";
import FatigueAssessmentDashboard from "components/portal/fatigueAssessment/FatigueAssessmentDashboard";
import FatigueAssessmentDashboardPending from "components/portal/fatigueAssessment/FatigueAssessmentDashboardPending";
import FatigueAssessmentDashboardToAction from "components/portal/fatigueAssessment/FatigueAssessmentDashboardToAction";
import FatigueAssessmentDashboardToRevisit from "components/portal/fatigueAssessment/FatigueAssessmentDashboardToRevisit";
import FatigueAssessmentDashboardCompleted from "components/portal/fatigueAssessment/FatigueAssessmentDashboardCompleted";
import FatigueAssessmentDashboardOverview from "components/portal/fatigueAssessment/FatigueAssessmentDashboardOverview";
import FatigueAssessmentDetails from "components/portal/fatigueAssessment/FatigueAssessmentDetails";
import { createElement } from 'react';


// Pages
const fatigueAssessmentPath = "/fatigueassessment";

export const dashboardPending = 'pending';
export const dashboardAction = 'action';
export const dashboardRevisit = 'revisit';
export const dashboardCompleted = 'completed';
export const dashboardOverview = 'overview';

const fatigueAssessmentDashboardPath = `${ fatigueAssessmentPath }/dashboard`;
const fatigueAssessmentPendingPath = `${ fatigueAssessmentDashboardPath }/${ dashboardPending }`;
const fatigueAssessmentActionPath = `${ fatigueAssessmentDashboardPath }/${ dashboardAction }`;
const fatigueAssessmentRevisitPath = `${ fatigueAssessmentDashboardPath }/${ dashboardRevisit }`;
const fatigueAssessmentCompletedPath = `${ fatigueAssessmentDashboardPath }/${ dashboardCompleted }`;
const fatigueAssessmentOverviewPath = `${ fatigueAssessmentDashboardPath }/${ dashboardOverview }`;

const fatigueAssessmentDetailsPath = `${ fatigueAssessmentDashboardPath }/:dashboardType/:id/:tab?`;

const fatigueAssessmentBlankFormPath = `${ fatigueAssessmentPath }/form`;
const fatigueAssessmentFormPath = `${ fatigueAssessmentBlankFormPath }/:id`;
const fatigueAssessmentOnBehalfPath = `${ fatigueAssessmentPath }/onbehalf`;
const fatigueAssessmentAssignPath = `${ fatigueAssessmentPath }/assign`;


// Routes
export const fatigueAssessmentRoute = {
    breadCrumb: "Fatigue Assessment",
    path: fatigueAssessmentPath,
    element: createElement(FatigueAssessments),
} as IRouteConfig;

export const fatigueAssessmentDashboardPathRoute = {
    breadCrumb: "Shift Summary Dashboard",
    permission: "web.admin.fatigue-assessment.shift-summary-dashboard",
    path: fatigueAssessmentDashboardPath,
    element: createElement(FatigueAssessmentDashboard),
} as IRouteConfig;

export const fatigueAssessmentPendingPathRoute = {
    breadCrumb: "Pending Fatigue Assessments",
    permission: "web.admin.fatigue-assessment.shift-summary-dashboard",
    path: fatigueAssessmentPendingPath,
    element: createElement(FatigueAssessmentDashboardPending),
} as IRouteConfig;

export const fatigueAssessmentActionPathRoute = {
    breadCrumb: "Fatigue Assessments to action",
    permission: "web.admin.fatigue-assessment.shift-summary-dashboard",
    path: fatigueAssessmentActionPath,
    element: createElement(FatigueAssessmentDashboardToAction),
} as IRouteConfig;

export const fatigueAssessmentRevisitPathRoute = {
    breadCrumb: "Fatigue Assessments to revisit",
    permission: "web.admin.fatigue-assessment.shift-summary-dashboard",
    path: fatigueAssessmentRevisitPath,
    element: createElement(FatigueAssessmentDashboardToRevisit),
} as IRouteConfig;

export const fatigueAssessmentCompletedPathRoute = {
    breadCrumb: "Completed - no action required",
    permission: "web.admin.fatigue-assessment.completed",
    path: fatigueAssessmentCompletedPath,
    element: createElement(FatigueAssessmentDashboardCompleted),
} as IRouteConfig;

export const fatigueAssessmentOverviewPathRoute = {
    breadCrumb: "Overview",
    permission: "web.admin.fatigue-assessment.completed",
    path: fatigueAssessmentOverviewPath,
    element: createElement(FatigueAssessmentDashboardOverview),
} as IRouteConfig;

export const fatigueAssessmentDetailsPathRoute = {
    breadCrumb: "Details",
    permission: "web.admin.fatigue-assessment.shift-summary-dashboard",
    path: fatigueAssessmentDetailsPath,
    element: createElement(FatigueAssessmentDetails),
} as IRouteConfig;

export const fatigueAssessmentBlankFormRoute = {
    breadCrumb: "Form",
    path: fatigueAssessmentBlankFormPath,
    element: createElement(FatigueAssessmentBaseForm),
    endTrail: true
} as IRouteConfig;

export const fatigueAssessmentFormRoute = {
    breadCrumb: undefined,
    path: fatigueAssessmentFormPath,
    element: createElement(FatigueAssessmentBaseForm)
} as IRouteConfig;

export const fatigueAssessmentOnBehalfRoute = {
    breadCrumb: "On-behalf form",
    permission: "web.admin.fatigue-assessment.on-behalf",
    path: fatigueAssessmentOnBehalfPath,
    element: createElement(FatigueAssessmentOnBehalfForm),
    endTrail: true
} as IRouteConfig;

export const fatigueAssessmentAssignRoute = {
    breadCrumb: "Assign",
    permission: "web.admin.fatigue-assessment.shift-summary-dashboard",
    path: fatigueAssessmentAssignPath,
    element: createElement(FatigueAssessmentAssignForm),
    endTrail: true
} as IRouteConfig;
